module.exports = __webpack_public_path__ + "media/message.f3df7f98.mp3";